/**
 * The back office's own strings, registered at import.
 *
 * Only the menu's areas: they gather several features' screens, so no feature
 * can name them, and `common` is a `core-*` namespace that may not hold a
 * business word. French and English, as the product features ship — see
 * `feature-referential/src/i18n.ts`.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "backoffice";

registerNamespace(NAMESPACE, { en, fr });
